var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-badge',{attrs:{"variant":"danger"}},[_c('b-icon',{attrs:{"icon":"record-fill","animation":"fade"}}),_c('span',{staticClass:"m-1 text-white"},[_vm._v("Live")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }